import { AsyncPipe, CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicValueResolvingModule } from '@epicuro-next/platform/dynamic-value-resolving';

import { DynamicComponentIfDirective } from './directives/dynamic-component-if.directive';
import { DynamicOperationIfPipe } from './pipes/dynamic-component-if.pipe';
import { LogicOperationsService } from './services/logic-operations.service';

@NgModule({
  imports: [CommonModule, DynamicValueResolvingModule],
  declarations: [DynamicComponentIfDirective, DynamicOperationIfPipe],
  providers: [LogicOperationsService, AsyncPipe],
  exports: [DynamicComponentIfDirective, DynamicOperationIfPipe],
})
export class DynamicLogicalOperationsModule {}
